/*!
 * JM Live Preview — Locket add-on v1.9.1 (Birthstone Heart Locket)
 * v1.9.1: "Leave it empty — I'll add my own photo" choice (saved as "Photo: Leave empty — customer adds
 *         their own"; Buy with Shop shows only in this mode, see jm-live-preview.css), Up/down + Left/right
 *         position sliders and a small whole-locket inset in the editor.
 * v1.9.0: photo editor pop-up (large heart close-up, drag / pinch / zoom / rotate / flip / reset),
 *         heart thumbnail with Edit / Replace / Remove, JPG + PNG only, low-resolution warning,
 *         required "I've checked my photo" tick (saved as "Photo approved"), crop file includes
 *         rotation + flip, "_Photo crop" now x,y,zoom,rotation,flip.
 * v1.8.1: inside view only (the locket holds one photo) — Front/Inside buttons removed.
 * Loaded after jm-live-preview.js (v1.6/1.7) on products whose metafield custom.preview_layout = "locket".
 * Adds: month picker + customer photo inside the heart, shown in the open locket,
 * birthstone swapped into the open locket, reflection updated, and the original + cropped photo
 * saved on the order as file properties ("Photo", "Photo (cropped)") with the crop in "_Photo crop".
 */
(function () {
  'use strict';
  var NS = window.JMLivePreview || {};
  var Preview = NS._tools && NS._tools.Preview;
  if (!Preview || Preview.prototype.__locket) return;
  Preview.prototype.__locket = true;

  var ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png';
  var MIN_PX = 260; // photo pixels across the heart below which we warn it may print soft

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function loadImg(url) {
    return new Promise(function (resolve, reject) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { resolve(i); };
      i.onerror = reject;
      i.src = url;
    });
  }

  /* ---------- styles for the photo box + editor (kept here so the theme CSS stays untouched) ---------- */
  function injectCSS() {
    if (document.getElementById('jmlp-locket-css')) return;
    var s = el('style', '', { id: 'jmlp-locket-css' });
    s.textContent = [
      '.jmlp__photo{border:1px solid rgba(0,0,0,.14);border-radius:10px;background:#fff;padding:.9em 1em;display:grid;gap:.6em}',
      '.jmlp__photo .jmlp__label{margin:0}',
      '.jmlp__photo-tip{margin:0;font-size:.78em;opacity:.65;line-height:1.4}',
      '.jmlp__photo-row{display:flex;align-items:center;gap:.8em;flex-wrap:wrap}',
      '.jmlp__photo-row[hidden]{display:none}',
      '.jmlp__lk-thumb{width:56px;height:56px;flex:none;border-radius:8px;background:#f6f5f3;display:block}',
      '.jmlp__lk-acts{display:flex;gap:1em;flex-wrap:wrap;align-items:center}',
      '.jmlp__lk-btn{height:44px;padding:0 1.4em;border:0;border-radius:999px;background:var(--jmlp-accent,#1a1a1a);color:#fff;font:inherit;cursor:pointer}',
      '.jmlp__lk-link{border:0;background:none;padding:.3em 0;font:inherit;font-size:.9em;color:inherit;text-decoration:underline;cursor:pointer}',
      '.jmlp__lk-warn{margin:0;font-size:.8em;color:#9a5b00;background:#fff6e5;border-radius:8px;padding:.5em .7em;line-height:1.35}',
      '.jmlp__lk-warn[hidden],.jmlp__msg[hidden]{display:none}',
      '.jmlp__msg{margin:0;font-size:.82em;color:#c0392b}',
      '.jmlp__lk-ok{display:flex;gap:.6em;align-items:flex-start;font-size:.85em;line-height:1.35;cursor:pointer}',
      '.jmlp__lk-ok[hidden]{display:none}',
      '.jmlp__lk-ok input{width:18px;height:18px;margin:.1em 0 0;flex:none;accent-color:var(--jmlp-accent,#1a1a1a)}',
      '.jmlp__lk-ok.is-invalid{color:#c0392b}',
      '.jmlp-ed{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);padding:16px}',
      '.jmlp-ed[hidden]{display:none}',
      '.jmlp-ed__panel{background:#fff;color:#1a1a1a;border-radius:16px;width:100%;max-width:460px;max-height:100%;overflow:auto;padding:16px;display:grid;gap:12px;box-shadow:0 20px 60px rgba(0,0,0,.3)}',
      '.jmlp-ed__head{display:flex;align-items:center;justify-content:space-between;gap:1em}',
      '.jmlp-ed__title{margin:0;font-size:1.05em;font-weight:600}',
      '.jmlp-ed__x{width:40px;height:40px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:inherit}',
      '.jmlp-ed__cv{display:block;width:100%;aspect-ratio:1/1;border-radius:12px;background:#f6f5f3;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}',
      '.jmlp-ed__cv:active{cursor:grabbing}',
      '.jmlp-ed__hint{margin:0;font-size:.78em;opacity:.6;text-align:center}',
      '.jmlp-ed__zoom{display:flex;align-items:center;gap:.6em}',
      '.jmlp-ed__zoom input{flex:1;accent-color:var(--jmlp-accent,#1a1a1a)}',
      '.jmlp-ed__tools{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}',
      '.jmlp-ed__tool,.jmlp-ed__zb{height:44px;border:1px solid rgba(0,0,0,.18);border-radius:10px;background:#fff;font:inherit;font-size:.88em;color:inherit;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:.4em}',
      '.jmlp-ed__zb{width:44px;flex:none;font-size:1.3em}',
      '.jmlp-ed__tool:hover,.jmlp-ed__zb:hover{background:#f6f5f3}',
      '.jmlp-ed__save{height:50px;border:0;border-radius:999px;background:var(--jmlp-accent,#1a1a1a);color:#fff;font:inherit;font-weight:600;letter-spacing:.04em;cursor:pointer}',
      '.jmlp-ed button:focus-visible{outline:2px solid var(--jmlp-accent,#1a1a1a);outline-offset:2px}',
      'html.jmlp-ed-open{overflow:hidden}',
      '.jmlp__lk-mode{display:grid;gap:.45em;border:0;margin:0;padding:0}',
      '.jmlp__lk-mode label{display:flex;gap:.6em;align-items:center;font-size:.92em;cursor:pointer}',
      '.jmlp__lk-mode input{width:18px;height:18px;margin:0;flex:none;accent-color:var(--jmlp-accent,#1a1a1a)}',
      '.jmlp__lk-own{margin:0;font-size:.8em;opacity:.7;line-height:1.4}',
      '.jmlp__lk-up{display:grid;gap:.6em}',
      '.jmlp__photo[data-mode="own"] .jmlp__lk-up{display:none}',
      '.jmlp__photo[data-mode="upload"] .jmlp__lk-own{display:none}',
      '.jmlp-ed__stage{position:relative;width:min(100%,52vh);width:min(100%,52dvh);margin-inline:auto}',
      '.jmlp-ed__stage .jmlp-ed__cv{width:100%}',
      '.jmlp-ed__inset{position:absolute;right:8px;top:8px;width:26%;aspect-ratio:1/1;border-radius:8px;background:#f6f5f3;box-shadow:0 2px 8px rgba(0,0,0,.18);pointer-events:none}',
      '.jmlp-ed__pos{display:grid;grid-template-columns:auto 1fr;gap:.35em .8em;align-items:center;font-size:.85em}',
      '.jmlp-ed__pos input{width:100%;accent-color:var(--jmlp-accent,#1a1a1a)}',
      '.jmlp-ed__pos [hidden]{display:none}',
      /* Buy with Shop can't carry an uploaded photo, so it only shows when the frame is left empty */
      'body:has(.jmlp__photo[data-mode="upload"]) .shopify-payment-button,body:has(.jmlp__photo[data-mode="upload"]) shopify-accelerated-checkout{display:none!important}',
      '@media (max-width:749px){.jmlp-ed{padding:0;align-items:flex-end}.jmlp-ed__panel{border-radius:16px 16px 0 0;max-width:none;padding:14px 16px calc(14px + env(safe-area-inset-bottom))}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* =====================================================================
   * LOCKET LAYOUT — Birthstone Heart Locket
   * Product metafield custom.preview_split (json), all positions as fractions of the photo:
   *  { "open": "heart-locket-open-{metal}.png",
   *    "window": [x0, y0, x1, y1], "rot": -3,           heart-shaped photo window (box + tilt in degrees)
   *    "stoneSrc": [cx, cy, r],                          stone in the month photo
   *    "stoneDst": { "gold": [cx, cy], "silver": [...] } stone in the open photo
   *    "reflect": { "gold": [axisY, x0, x1, depth], ... } mirror line under the locket
   *    "focusFront": [cx, cy, size], "focusInside": [cx, cy, size],
   *    "photoRequired": true }
   * ===================================================================== */
  var HEART = [ // unit heart, top-left (0,0) to bottom-right (1,1): start point then cubic segments
    [0.5, 0.07],
    [0.49, 0.03, 0.42, 0, 0.27, 0], [0.04, 0, 0, 0.18, 0, 0.3], [0, 0.5, 0.2, 0.72, 0.5, 1],
    [0.8, 0.72, 1, 0.5, 1, 0.3], [1, 0.18, 0.96, 0, 0.73, 0], [0.58, 0, 0.51, 0.03, 0.5, 0.07]
  ];
  function heartPath(x, b, pad) {
    var X = b.x - pad, Y = b.y - pad, w = b.w + pad * 2, h = b.h + pad * 2;
    x.beginPath();
    x.moveTo(X + HEART[0][0] * w, Y + HEART[0][1] * h);
    for (var i = 1; i < HEART.length; i++) {
      var p = HEART[i];
      x.bezierCurveTo(X + p[0] * w, Y + p[1] * h, X + p[2] * w, Y + p[3] * h, X + p[4] * w, Y + p[5] * h);
    }
    x.closePath();
  }
  var lkImgCache = {};
  function lkImg(url) {
    if (!lkImgCache[url]) {
      lkImgCache[url] = loadImg(url);
      lkImgCache[url].catch(function () { delete lkImgCache[url]; });
    }
    return lkImgCache[url];
  }
  function setInputFile(input, file) {
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      input.files = dt.files;
      input.disabled = false;
      return true;
    } catch (e) { return false; }
  }
  // draw the customer's photo centred at (cx, cy) with scale sc, rotation r (deg) and flip
  function drawPhoto(x, img, cx, cy, sc, crop) {
    x.save();
    x.translate(cx, cy);
    x.rotate((crop.r || 0) * Math.PI / 180);
    if (crop.f) x.scale(-1, 1);
    var w = img.naturalWidth * sc, h = img.naturalHeight * sc;
    x.drawImage(img, -w / 2, -h / 2, w, h);
    x.restore();
  }

  Preview.prototype.buildLocketUI = function () {
    var self = this, lk = this.lk;
    injectCSS();
    var box = el('div', 'jmlp__photo', { 'data-mode': 'upload' });
    box.innerHTML =
      '<p class="jmlp__label">' + (lk.photoLabel || 'Your photo') + '</p>' +
      '<fieldset class="jmlp__lk-mode"><legend class="jmlp__visually-hidden" style="position:absolute;clip:rect(0 0 0 0);width:1px;height:1px;overflow:hidden">Photo</legend>' +
        '<label><input type="radio" name="jmlp-lk-mode" value="upload" checked data-lk-mode> Add my photo</label>' +
        '<label><input type="radio" name="jmlp-lk-mode" value="own" data-lk-mode> Leave it empty — I\'ll add my own photo</label>' +
      '</fieldset>' +
      '<p class="jmlp__lk-own">Your locket arrives with the frame empty, ready for a photo of your choice.</p>' +
      '<div class="jmlp__lk-up" data-lk-upload>' +
      '<p class="jmlp__photo-tip" data-lk-tip>The heart is fingertip-sized, so a close-up of faces works best. JPG or PNG.</p>' +
      '<div class="jmlp__photo-row" data-lk-empty>' +
        '<button type="button" class="jmlp__lk-btn" data-lk-add>' + (lk.addText || 'Add your photo') + '</button>' +
      '</div>' +
      '<div class="jmlp__photo-row" data-lk-has hidden>' +
        '<canvas class="jmlp__lk-thumb" width="112" height="112" data-lk-thumb aria-label="Your photo as it will sit in the heart"></canvas>' +
        '<div class="jmlp__lk-acts">' +
          '<button type="button" class="jmlp__lk-btn" data-lk-edit>Adjust photo</button>' +
          '<button type="button" class="jmlp__lk-link" data-lk-replace>Replace</button>' +
          '<button type="button" class="jmlp__lk-link" data-lk-remove>Remove</button>' +
        '</div>' +
      '</div>' +
      '<p class="jmlp__lk-warn" data-lk-warn hidden></p>' +
      '<label class="jmlp__lk-ok" data-lk-okwrap hidden><input type="checkbox" data-lk-ok>' +
        '<span>I\'ve checked my photo in the preview and I\'m happy for it to be printed exactly as shown.</span></label>' +
      '</div>' +
      '<p class="jmlp__msg" data-lk-msg hidden></p>';
    this.stonesEl.parentNode.insertBefore(box, this.stonesEl.nextSibling);
    var q = function (s) { return box.querySelector(s); };
    this.lkUI = {
      root: box, empty: q('[data-lk-empty]'), has: q('[data-lk-has]'), thumb: q('[data-lk-thumb]'),
      warn: q('[data-lk-warn]'), okWrap: q('[data-lk-okwrap]'), ok: q('[data-lk-ok]'), msg: q('[data-lk-msg]')
    };

    // file inputs live inside the add-to-cart form(s) so the theme's FormData sends them to the cart
    this.lkFiles = this.forms.map(function (form) {
      var wrap = el('div', 'jmlp__files');
      wrap.hidden = true;
      var orig = el('input', '', { type: 'file', accept: ACCEPT, name: 'properties[Photo]', tabindex: '-1' });
      var crop = el('input', '', { type: 'file', name: 'properties[Photo (cropped)]', tabindex: '-1' });
      orig.disabled = true; crop.disabled = true;
      wrap.appendChild(orig); wrap.appendChild(crop);
      form.appendChild(wrap);
      return { orig: orig, crop: crop };
    });
    // a separate picker, so a cancelled "Replace" never wipes the photo already chosen
    var picker = el('input', '', { type: 'file', accept: ACCEPT, hidden: '', tabindex: '-1' });
    box.appendChild(picker);
    this.lkPicker = picker;
    function pick() { picker.value = ''; picker.click(); }
    q('[data-lk-add]').addEventListener('click', pick);
    q('[data-lk-replace]').addEventListener('click', pick);
    q('[data-lk-edit]').addEventListener('click', function () { self.openEditor(); });
    q('[data-lk-remove]').addEventListener('click', function () { self.clearPhoto(); });
    picker.addEventListener('change', function () {
      var f = picker.files && picker.files[0];
      if (f) self.setPhoto(f);
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-lk-mode]'), function (r) {
      r.addEventListener('change', function () { if (r.checked) self.setMode(r.value); });
    });
    this.lkUI.ok.addEventListener('change', function () {
      self.lkUI.okWrap.classList.remove('is-invalid');
      if (self.lkUI.ok.checked) self.lkUI.msg.hidden = true;
      self.writeProps();
    });
    this.buildEditor();
    this.bindLocketDrag();
    if (lk.hideOtherUploads !== false) this.hideOtherUploads();
  };

  // "upload" = customer's photo printed inside; "own" = frame left empty, customer adds their own photo
  Preview.prototype.setMode = function (mode) {
    this.state.noPhoto = mode === 'own';
    this.lkUI.root.setAttribute('data-mode', this.state.noPhoto ? 'own' : 'upload');
    Array.prototype.forEach.call(this.lkUI.root.querySelectorAll('[data-lk-mode]'), function (r) { r.checked = r.value === mode; });
    var off = this.state.noPhoto;
    // the uploaded files only go to the cart in "upload" mode
    this.lkFiles.forEach(function (f) {
      f.orig.disabled = off || !(f.orig.files && f.orig.files.length);
      f.crop.disabled = off || !(f.crop.files && f.crop.files.length);
    });
    this.lkUI.msg.hidden = true;
    this.render();
  };

  /* ---------- the photo editor pop-up ---------- */
  Preview.prototype.buildEditor = function () {
    var self = this;
    var ed = el('div', 'jmlp-ed', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'jmlp-ed-title' });
    ed.hidden = true;
    ed.innerHTML =
      '<div class="jmlp-ed__panel">' +
        '<div class="jmlp-ed__head"><p class="jmlp-ed__title" id="jmlp-ed-title">Position your photo</p>' +
          '<button type="button" class="jmlp-ed__x" data-ed-close aria-label="Close">&times;</button></div>' +
        '<div class="jmlp-ed__stage">' +
          '<canvas class="jmlp-ed__cv" width="900" height="900" data-ed-cv tabindex="0" aria-label="Your photo inside the locket. Drag to move; use the arrow keys to nudge and + or - to zoom."></canvas>' +
          '<canvas class="jmlp-ed__inset" width="240" height="240" data-ed-inset aria-hidden="true"></canvas>' +
        '</div>' +
        '<p class="jmlp-ed__hint">Drag to move · pinch or use the slider to zoom</p>' +
        '<p class="jmlp__lk-warn" data-ed-warn hidden></p>' +
        '<div class="jmlp-ed__zoom">' +
          '<button type="button" class="jmlp-ed__zb" data-ed-zout aria-label="Zoom out">&minus;</button>' +
          '<input type="range" min="1" max="4" step="0.01" value="1" aria-label="Zoom" data-ed-range>' +
          '<button type="button" class="jmlp-ed__zb" data-ed-zin aria-label="Zoom in">+</button>' +
        '</div>' +
        '<div class="jmlp-ed__pos">' +
          '<label for="jmlp-ed-py" data-ed-pyl>Up / down</label><input id="jmlp-ed-py" type="range" min="-1" max="1" step="0.005" value="0" data-ed-py>' +
          '<label for="jmlp-ed-px" data-ed-pxl>Left / right</label><input id="jmlp-ed-px" type="range" min="-1" max="1" step="0.005" value="0" data-ed-px>' +
        '</div>' +
        '<div class="jmlp-ed__tools">' +
          '<button type="button" class="jmlp-ed__tool" data-ed-rot>&#x21bb; Rotate</button>' +
          '<button type="button" class="jmlp-ed__tool" data-ed-flip>&#x21c6; Flip</button>' +
          '<button type="button" class="jmlp-ed__tool" data-ed-reset>Reset</button>' +
        '</div>' +
        '<button type="button" class="jmlp-ed__save" data-ed-save>Save photo</button>' +
      '</div>';
    document.body.appendChild(ed);
    var q = function (s) { return ed.querySelector(s); };
    this.ed = { root: ed, cv: q('[data-ed-cv]'), range: q('[data-ed-range]'), warn: q('[data-ed-warn]'), save: q('[data-ed-save]'),
      inset: q('[data-ed-inset]'), py: q('[data-ed-py]'), px: q('[data-ed-px]'), pyl: q('[data-ed-pyl]'), pxl: q('[data-ed-pxl]') };
    // position sliders: -1..1 of the room the photo has to move in each direction
    [['py', 'y', 'my'], ['px', 'x', 'mx']].forEach(function (a) {
      self.ed[a[0]].addEventListener('input', function () {
        var lim = (self.lkLimits && self.lkLimits[a[2]]) || 0;
        self.state.crop[a[1]] = (parseFloat(self.ed[a[0]].value) || 0) * lim;
        self._slid = a[0];
        self.drawLocket();
        self._slid = null;
      });
    });
    var crop = function () { return self.state.crop; };
    function zoomTo(z) {
      crop().z = Math.max(1, Math.min(4, z));
      self.ed.range.value = crop().z;
      self.drawLocket();
    }
    this.ed.zoomTo = zoomTo;
    this.ed.range.addEventListener('input', function () { zoomTo(parseFloat(self.ed.range.value) || 1); });
    q('[data-ed-zin]').addEventListener('click', function () { zoomTo(crop().z + 0.2); });
    q('[data-ed-zout]').addEventListener('click', function () { zoomTo(crop().z - 0.2); });
    q('[data-ed-rot]').addEventListener('click', function () { crop().r = ((crop().r || 0) + 90) % 360; self.drawLocket(); });
    q('[data-ed-flip]').addEventListener('click', function () { crop().f = !crop().f; self.drawLocket(); });
    q('[data-ed-reset]').addEventListener('click', function () { self.state.crop = { x: 0, y: 0, z: 1, r: 0, f: false }; self.ed.range.value = 1; self.drawLocket(); });
    q('[data-ed-close]').addEventListener('click', function () { self.closeEditor(); });
    this.ed.save.addEventListener('click', function () { self.closeEditor(); });
    ed.addEventListener('click', function (e) { if (e.target === ed) self.closeEditor(); });
    ed.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeEditor(); return; }
      if (e.key === 'Tab') { // keep focus inside the pop-up
        var f = Array.prototype.filter.call(ed.querySelectorAll('button, input, [tabindex="0"]'), function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    this.ed.cv.addEventListener('keydown', function (e) {
      var st = 0.02, c = crop(), used = true;
      if (e.key === 'ArrowLeft') c.x -= st; else if (e.key === 'ArrowRight') c.x += st;
      else if (e.key === 'ArrowUp') c.y -= st; else if (e.key === 'ArrowDown') c.y += st;
      else if (e.key === '+' || e.key === '=') { zoomTo(c.z + 0.1); e.preventDefault(); return; }
      else if (e.key === '-') { zoomTo(c.z - 0.1); e.preventDefault(); return; }
      else used = false;
      if (used) { e.preventDefault(); self.drawLocket(); }
    });
    // drag with one finger / mouse, pinch with two fingers, ctrl/trackpad wheel to zoom
    var pts = {}, start = null;
    function snapshot() {
      var ids = Object.keys(pts), c = crop();
      if (ids.length === 1) start = { mode: 'drag', x: pts[ids[0]].x, y: pts[ids[0]].y, cx: c.x, cy: c.y };
      else if (ids.length >= 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        start = { mode: 'pinch', d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: c.z };
      } else start = null;
    }
    var cv = this.ed.cv;
    cv.addEventListener('pointerdown', function (e) {
      if (!self.state.photo) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      snapshot(); e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId] || !start) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var c = crop();
      if (start.mode === 'drag') {
        var v = self.edView(), k = v.S / cv.getBoundingClientRect().width;
        var b = self.windowBox(v.W, v.H);
        c.x = start.cx + (e.clientX - start.x) * k / b.w;
        c.y = start.cy + (e.clientY - start.y) * k / b.h;
        self.drawLocket();
      } else {
        var ids = Object.keys(pts), a = pts[ids[0]], bb = pts[ids[1]];
        zoomTo(start.z * Math.hypot(a.x - bb.x, a.y - bb.y) / start.d);
      }
    });
    function up(e) { delete pts[e.pointerId]; snapshot(); }
    cv.addEventListener('pointerup', up);
    cv.addEventListener('pointercancel', up);
    cv.addEventListener('wheel', function (e) {
      if (!self.state.photo) return;
      e.preventDefault();
      zoomTo(crop().z * Math.exp(-e.deltaY * 0.002));
    }, { passive: false });
  };

  // the part of the open-locket photo the editor shows: a square around the heart window
  Preview.prototype.edView = function () {
    var base = (this.lkImgs && (this.lkImgs.open || this.lkImgs.front));
    var W = base ? base.naturalWidth : 2048, H = base ? base.naturalHeight : 2048;
    var b = this.windowBox(W, H), S = Math.max(b.w, b.h) * (this.lk.editorSpan || 1.7);
    return { W: W, H: H, S: S, x: b.x + b.w / 2 - S / 2, y: b.y + b.h / 2 - S / 2 };
  };

  Preview.prototype.paintEditor = function () {
    if (!this.ed || this.ed.root.hidden || !this.canvas) return;
    var v = this.edView(), cv = this.ed.cv, x = cv.getContext('2d');
    x.fillStyle = '#f6f5f3'; x.fillRect(0, 0, cv.width, cv.height);
    x.imageSmoothingQuality = 'high';
    x.drawImage(this.canvas, v.x, v.y, v.S, v.S, 0, 0, cv.width, cv.height);
    // small whole-locket view, as it looks in the main product photo
    var ins = this.ed.inset, f = this.focus;
    if (ins && f) {
      var ix = ins.getContext('2d');
      ix.fillStyle = '#f6f5f3'; ix.fillRect(0, 0, ins.width, ins.height);
      ix.imageSmoothingQuality = 'high';
      ix.drawImage(this.canvas, f.x, f.y, f.s, f.s, 0, 0, ins.width, ins.height);
    }
    // keep the position sliders in step with dragging / zooming; hide one with no room to move
    var L = this.lkLimits || { mx: 0, my: 0 }, c = this.state.crop, ed = this.ed;
    [['py', 'pyl', 'y', 'my'], ['px', 'pxl', 'x', 'mx']].forEach(function (a) {
      var room = L[a[3]] > 0.002;
      ed[a[0]].hidden = ed[a[1]].hidden = !room;
      if (room && this._slid !== a[0]) ed[a[0]].value = Math.max(-1, Math.min(1, c[a[2]] / L[a[3]]));
    }, this);
  };

  Preview.prototype.openEditor = function () {
    if (!this.state.photo || !this.ed) return;
    this._edReturn = document.activeElement;
    this.ed.range.value = this.state.crop.z;
    this.ed.root.hidden = false;
    document.documentElement.classList.add('jmlp-ed-open');
    this.drawLocket();
    var cv = this.ed.cv;
    setTimeout(function () { try { cv.focus({ preventScroll: true }); } catch (e) {} }, 30);
  };

  Preview.prototype.closeEditor = function () {
    if (!this.ed || this.ed.root.hidden) return;
    this.ed.root.hidden = true;
    document.documentElement.classList.remove('jmlp-ed-open');
    this.lkChanged();
    var back = this.lkUI && this.lkUI.has.querySelector('[data-lk-edit]');
    try { (back || this._edReturn).focus({ preventScroll: true }); } catch (e) {}
  };

  // The product may also have an app upload field (e.g. King Product Options): hide it so there is one upload.
  Preview.prototype.hideOtherUploads = function () {
    var self = this;
    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('input[type="file"]'), function (inp) {
        if (self.lkFiles.some(function (f) { return f.orig === inp || f.crop === inp; }) || inp === self.lkPicker) return;
        var n = inp.closest('[class*="ymq"]');
        if (!n) return;
        while (n.parentElement && /ymq/.test(n.parentElement.className || '') &&
               n.parentElement.querySelectorAll('input, select, textarea').length === n.querySelectorAll('input, select, textarea').length) n = n.parentElement;
        n.style.display = 'none';
        n.setAttribute('data-jmlp-hidden-upload', '');
      });
    }
    run(); setTimeout(run, 1200); setTimeout(run, 3500);
  };

  Preview.prototype.setView = function () {
    this.state.view = 'inside'; // the locket holds one photo, so the preview always shows it open
    this.stage.classList.toggle('jmlp__stage--drag', !!this.state.photo);
    this.render();
    this.activateSlide();
  };

  Preview.prototype.lkError = function (text) {
    this.lkUI.msg.textContent = text;
    this.lkUI.msg.hidden = false;
  };

  Preview.prototype.setPhoto = function (file) {
    var self = this;
    var okType = /^image\/(jpe?g|png)$/i.test(file.type || '') || (!file.type && /\.(jpe?g|png)$/i.test(file.name || ''));
    if (!okType) {
      this.lkError('Sorry, that file type won\'t print — please choose a JPG or PNG photo.');
      return;
    }
    var url = URL.createObjectURL(file);
    loadImg(url).then(function (img) {
      if (self.state.photo && self.state.photo.url) URL.revokeObjectURL(self.state.photo.url);
      self.state.photo = { img: img, url: url, name: file.name, file: file };
      self.state.crop = { x: 0, y: 0, z: 1, r: 0, f: false };
      self.lkUI.empty.hidden = true;
      self.lkUI.has.hidden = false;
      self.lkUI.okWrap.hidden = false;
      self.lkUI.ok.checked = false;
      self.lkUI.msg.hidden = true;
      self.lkFiles.forEach(function (f) { setInputFile(f.orig, file); });
      self.setView('inside');
      self.lkChanged();
      self.openEditor();
    }).catch(function () {
      URL.revokeObjectURL(url);
      self.lkError('Sorry, that photo could not be opened — please try a JPG or PNG.');
    });
  };

  Preview.prototype.clearPhoto = function () {
    if (this.state.photo && this.state.photo.url) URL.revokeObjectURL(this.state.photo.url);
    this.state.photo = null;
    this.state.crop = { x: 0, y: 0, z: 1, r: 0, f: false };
    this.lkUI.empty.hidden = false;
    this.lkUI.has.hidden = true;
    this.lkUI.okWrap.hidden = true;
    this.lkUI.ok.checked = false;
    this.lkUI.warn.hidden = true;
    this.lkUI.msg.hidden = true;
    this.lkFiles.forEach(function (f) {
      try { f.orig.value = ''; } catch (e) {}
      try { f.crop.value = ''; } catch (e) {}
      f.orig.disabled = true; f.crop.disabled = true;
    });
    this.setView('inside');
    this.writeProps();
  };

  // after a photo / crop change: refresh cart properties now, the cropped file a moment later
  Preview.prototype.lkChanged = function () {
    var self = this;
    this.writeProps();
    clearTimeout(this._lkT);
    this._lkT = setTimeout(function () { self.exportCrop(); }, 250);
  };

  Preview.prototype.windowBox = function (W, H) {
    var w = this.lk.window || [0.43, 0.65, 0.56, 0.78];
    return { x: w[0] * W, y: w[1] * H, w: (w[2] - w[0]) * W, h: (w[3] - w[1]) * H, rot: (this.lk.rot || 0) * Math.PI / 180 };
  };

  // where the customer's photo sits: covers the window at zoom 1, never leaves a gap
  Preview.prototype.photoPlacement = function (b) {
    var p = this.state.photo, c = this.state.crop;
    var turned = ((c.r || 0) / 90) % 2 === 1;
    var iw = turned ? p.img.naturalHeight : p.img.naturalWidth, ih = turned ? p.img.naturalWidth : p.img.naturalHeight;
    var sc = Math.max(b.w / iw, b.h / ih) * c.z;
    var dw = iw * sc, dh = ih * sc;
    var mx = Math.max(0, (dw - b.w) / 2 / b.w), my = Math.max(0, (dh - b.h) / 2 / b.h);
    c.x = Math.max(-mx, Math.min(mx, c.x)); c.y = Math.max(-my, Math.min(my, c.y));
    this.lkLimits = { mx: mx, my: my };
    return { sc: sc, dw: dw, dh: dh, cx: b.x + b.w / 2 + c.x * b.w, cy: b.y + b.h / 2 + c.y * b.h, srcPx: b.w / sc };
  };

  Preview.prototype.renderLocket = function (token) {
    var self = this, metal = this.state.metal || 'gold', mIdx = this.state.stones[0];
    var front = this.fileUrl(this.cfg.photos, metal, mIdx, 2048);
    var jobs = [lkImg(front), lkImg(this.fileUrl(this.lk.open || '', metal, mIdx, 2048))];
    return Promise.all(jobs).then(function (res) {
      if (token !== self.renderToken) return;
      self.lkImgs = { front: res[0], open: res[1] || null, metal: metal };
      self.drawLocket();
    });
  };

  Preview.prototype.drawLocket = function () {
    var I = this.lkImgs;
    if (!I) return;
    var lk = this.lk, inside = !!I.open;
    var base = inside ? I.open : I.front;
    var W = base.naturalWidth, H = base.naturalHeight;
    var cv = this.canvas;
    if (!cv) { cv = this.canvas = el('canvas', 'jmlp__canvas', { role: 'img' }); this.stage.insertBefore(cv, this.layersEl); }
    if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
    var x = cv.getContext('2d');
    x.drawImage(base, 0, 0, W, H);
    var label = this.recipe().stones.map(function (s) { return s.label; }).join(', ');
    if (inside) {
      // 1) birthstone: cut the stone from the month photo and set it into the open locket
      var ss = lk.stoneSrc, sd = lk.stoneDst && (lk.stoneDst[I.metal] || lk.stoneDst.gold);
      if (ss && sd) {
        var fW = I.front.naturalWidth, fH = I.front.naturalHeight, r = ss[2] * fW, R = Math.ceil(r * 1.25);
        var tmp = document.createElement('canvas'); tmp.width = tmp.height = R * 2;
        var t = tmp.getContext('2d');
        t.drawImage(I.front, ss[0] * fW - R, ss[1] * fH - R, R * 2, R * 2, 0, 0, R * 2, R * 2);
        var g = t.createRadialGradient(R, R, r * 0.72, R, R, r * 1.02);
        g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        t.globalCompositeOperation = 'destination-in'; t.fillStyle = g; t.fillRect(0, 0, R * 2, R * 2);
        var k = W / fW;
        x.drawImage(tmp, sd[0] * W - R * k, sd[1] * H - R * k, R * 2 * k, R * 2 * k);
      }
      // 2) the customer's photo inside the heart (not when they're leaving it empty)
      if (this.state.photo && !this.state.noPhoto) {
        var b = this.windowBox(W, H), pl = this.photoPlacement(b), pad = W * 0.0028;
        x.save();
        x.translate(b.x + b.w / 2, b.y + b.h / 2); x.rotate(b.rot); x.translate(-(b.x + b.w / 2), -(b.y + b.h / 2));
        heartPath(x, b, pad); x.clip();
        x.fillStyle = '#fff'; x.fillRect(b.x - pad, b.y - pad, b.w + pad * 2, b.h + pad * 2);
        drawPhoto(x, this.state.photo.img, pl.cx, pl.cy, pl.sc, this.state.crop);
        x.lineWidth = W * 0.005; x.strokeStyle = 'rgba(60,40,10,.22)';
        heartPath(x, b, pad); x.stroke();
        x.lineWidth = W * 0.0015; x.strokeStyle = 'rgba(0,0,0,.25)';
        heartPath(x, b, pad); x.stroke();
        x.restore();
        label += ' — with your photo inside';
        this.lkQuality(pl.srcPx);
      }
      // 3) reflection: change it by the same amount the locket changed, mirrored
      this.lkReflect(x, I, W, H);
    }
    cv.setAttribute('aria-label', label);
    var fz = (inside ? lk.focusInside : lk.focusFront) || [0.5, 0.7, 0.5];
    var fs = Math.min(W, H, W * fz[2]);
    this.focus = { x: Math.max(0, Math.min(W - fs, W * fz[0] - fs / 2)), y: Math.max(0, Math.min(H - fs, H * fz[1] - fs / 2)), s: fs };
    this.paintCopies();
    this.paintEditor();
    this.stage.classList.add('jmlp__stage--canvas');
  };

  // warn when the part of the photo inside the heart has too few pixels to print sharply
  Preview.prototype.lkQuality = function (srcPx) {
    var low = srcPx < MIN_PX;
    var txt = low ? 'This photo may print a little blurry at this zoom. Try zooming out, or use a larger / sharper photo.' : '';
    [this.lkUI && this.lkUI.warn, this.ed && this.ed.warn].forEach(function (n) {
      if (!n) return;
      n.textContent = txt; n.hidden = !low;
    });
  };

  Preview.prototype.lkReflect = function (x, I, W, H) {
    var rf = this.lk.reflect && (this.lk.reflect[I.metal] || this.lk.reflect.gold);
    if (!rf) return;
    try {
      var Y = Math.round(rf[0] * H), x0 = Math.round(rf[1] * W), x1 = Math.round(rf[2] * W);
      var D = Math.min(Math.round(rf[3] * H), Y, H - Y), w = x1 - x0;
      var a0 = this.lk.reflectAlpha || 0.52, tau = (this.lk.reflectFade || 0.21) * H;
      var key = I.metal + ':' + W;
      this.lkOrig = this.lkOrig || {};
      if (!this.lkOrig[key]) {
        var o = document.createElement('canvas'); o.width = W; o.height = H;
        var oc = o.getContext('2d'); oc.drawImage(I.open, 0, 0, W, H);
        this.lkOrig[key] = { above: oc.getImageData(x0, Y - D, w, D).data, below: oc.getImageData(x0, Y, w, D) };
      }
      var orig = this.lkOrig[key];
      var cur = x.getImageData(x0, Y - D, w, D).data;
      var out = new ImageData(new Uint8ClampedArray(orig.below.data), w, D), od = out.data;
      for (var d = 0; d < D; d++) {
        var a = a0 * Math.exp(-d / tau), src = (D - 1 - d) * w * 4, dst = d * w * 4;
        for (var i = 0; i < w * 4; i += 4) {
          var s = src + i, t = dst + i;
          od[t] += a * (cur[s] - orig.above[s]);
          od[t + 1] += a * (cur[s + 1] - orig.above[s + 1]);
          od[t + 2] += a * (cur[s + 2] - orig.above[s + 2]);
        }
      }
      x.putImageData(out, x0, Y);
    } catch (e) {}
  };

  // drag the photo inside the heart on the main preview too (mouse, pen or finger)
  Preview.prototype.bindLocketDrag = function () {
    var self = this, st = this.stage, drag = null;
    st.addEventListener('pointerdown', function (e) {
      if (!self.state.photo || !self.canvas) return;
      var r = self.canvas.getBoundingClientRect();
      drag = { x: e.clientX, y: e.clientY, k: self.canvas.width / r.width, c: { x: self.state.crop.x, y: self.state.crop.y } };
      try { st.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    st.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var b = self.windowBox(self.canvas.width, self.canvas.height);
      self.state.crop.x = drag.c.x + (e.clientX - drag.x) * drag.k / b.w;
      self.state.crop.y = drag.c.y + (e.clientY - drag.y) * drag.k / b.h;
      self.drawLocket();
    });
    function end() { if (drag) { drag = null; self.lkChanged(); } }
    st.addEventListener('pointerup', end);
    st.addEventListener('pointercancel', end);
  };

  // the part of the photo that shows in the heart, as its own image file for the workshop
  Preview.prototype.exportCrop = function () {
    var self = this, p = this.state.photo;
    if (!p || !this.lkImgs || this.state.noPhoto) return;
    var base = this.lkImgs.open || this.lkImgs.front, W = base.naturalWidth, H = base.naturalHeight;
    var b = this.windowBox(W, H), pl = this.photoPlacement(b);
    var ow = Math.round(Math.max(600, Math.min(1600, pl.srcPx))), k = ow / b.w, oh = Math.round(b.h * k);
    var c = document.createElement('canvas'); c.width = ow; c.height = oh;
    var x = c.getContext('2d');
    x.fillStyle = '#fff'; x.fillRect(0, 0, ow, oh);
    x.imageSmoothingQuality = 'high';
    drawPhoto(x, p.img, (pl.cx - b.x) * k, (pl.cy - b.y) * k, pl.sc * k, this.state.crop);
    // heart thumbnail next to the Adjust button
    var th = this.lkUI && this.lkUI.thumb;
    if (th) {
      var tx = th.getContext('2d'), T = th.width, m = T * 0.08, hb = { x: m, y: m, w: T - m * 2, h: T - m * 2 };
      tx.clearRect(0, 0, T, T);
      tx.save(); heartPath(tx, hb, 0); tx.clip(); tx.drawImage(c, hb.x, hb.y, hb.w, hb.h); tx.restore();
      tx.lineWidth = 3; tx.strokeStyle = '#c9a85c'; heartPath(tx, hb, 0); tx.stroke();
    }
    c.toBlob(function (blob) {
      if (!blob || self.state.photo !== p) return;
      var nm = (p.name || 'photo').replace(/\.[^.]+$/, '') + '-cropped.jpg';
      var file = new File([blob], nm, { type: 'image/jpeg' });
      self.lkFiles.forEach(function (f) { setInputFile(f.crop, file); });
    }, 'image/jpeg', 0.92);
  };

  /* ----- hook into the core preview ----- */
  var P = Preview.prototype;
  var coreRender = P.render, coreSwatch = P.swatchFor, coreProps = P.writeProps, coreValidate = P.validate;

  P.render = function () {
    if (!this.locket) return coreRender.apply(this, arguments);
    var self = this, token = ++this.renderToken;
    this.loading.hidden = false;
    this.renderLocket(token).catch(function (e) {
      if (window.Shopify && window.Shopify.designMode) console.warn('[JM Live Preview locket]', e);
      self.stage.classList.remove('jmlp__stage--canvas');
      if (self.cfg.fallbackImage) self.base.src = self.cfg.fallbackImage;
    }).then(function () { if (token === self.renderToken) self.loading.hidden = true; });
    this.writeProps();
    this.root.dispatchEvent(new CustomEvent('jmlp:change', { bubbles: true, detail: this.recipe() }));
  };

  P.swatchFor = function (mIdx) {
    if (!this.locket) return coreSwatch.apply(this, arguments);
    var m = this.months[mIdx];
    if (!m) return Promise.resolve(null);
    var metal = this.state.metal || 'gold', ck = 'lk:' + metal + ':' + m.key, ss = this.lk.stoneSrc || [0.5, 0.5, 0.01];
    this.swatchCache = this.swatchCache || {};
    if (!this.swatchCache[ck]) {
      this.swatchCache[ck] = lkImg(this.fileUrl(this.cfg.photos, metal, mIdx, 2048)).then(function (img) {
        var W = img.naturalWidth, s = ss[2] * W * 2.6;
        var c = document.createElement('canvas'); c.width = c.height = 96;
        c.getContext('2d').drawImage(img, ss[0] * W - s / 2, ss[1] * img.naturalHeight - s / 2, s, s, 0, 0, 96, 96);
        return c.toDataURL('image/jpeg', 0.88);
      }).catch(function () { return null; });
    }
    return this.swatchCache[ck];
  };

  P.writeProps = function () {
    coreProps.apply(this, arguments);
    if (!this.locket || !this.propsBoxes) return;
    if (this.state.noPhoto) {
      this.propsBoxes.forEach(function (box) {
        var n = document.createElement('input');
        n.type = 'hidden'; n.name = 'properties[Photo]'; n.value = 'Leave empty — customer adds their own';
        box.appendChild(n);
      });
      return;
    }
    if (!this.state.photo) return;
    var cr = this.state.crop, v = [cr.x.toFixed(3), cr.y.toFixed(3), cr.z.toFixed(2), (cr.r || 0), cr.f ? 'flip' : 'noflip'].join(',');
    var ok = this.lkUI && this.lkUI.ok.checked;
    this.propsBoxes.forEach(function (box) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[_Photo crop]'; i.value = v;
      box.appendChild(i);
      if (ok) {
        var a = document.createElement('input');
        a.type = 'hidden'; a.name = 'properties[Photo approved]'; a.value = 'Yes';
        box.appendChild(a);
      }
    });
  };

  P.validate = function () {
    if (this.locket && this.lkUI && !this.state.noPhoto) {
      if (this.lk.photoRequired && !this.state.photo) {
        this.lkError('Please add the photo you\'d like inside your locket.');
        this.lkUI.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      if (this.state.photo && !this.lkUI.ok.checked) {
        this.lkError('Please check your photo in the preview and tick the box to confirm.');
        this.lkUI.okWrap.classList.add('is-invalid');
        this.lkUI.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }
    return coreValidate.apply(this, arguments);
  };

  /* ----- switch on for preview roots set to the locket layout ----- */
  function initLocket(inst) {
    if (!inst || inst.locket || !inst.cfg || inst.cfg.layout !== 'locket') return;
    inst.locket = true;
    inst.split = false; inst.countIdx = -1; inst.cfg.maxStones = 1;
    inst.lk = inst.cfg.splitCfg || {};
    inst.photoMode = !!inst.cfg.photos;
    inst.state.count = 1;
    inst.state.photo = null; inst.state.view = 'inside'; inst.state.crop = { x: 0, y: 0, z: 1, r: 0, f: false };
    inst.swatchCache = {};
    if (inst.countWrap) inst.countWrap.hidden = true;
    inst.buildLocketUI();
    inst.buildRows();
    inst.render();
  }
  function scan() {
    document.querySelectorAll('[data-jmlp]').forEach(function (root) { initLocket(root.__jmlp); });
  }
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(scan, 0); });
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });
})();
